var App = App || {};

App.BlogPosts = (function ($) {
    "use strict";

    function init() {

        var mastheadFeaturedPosts = $(".item-blog-post-featured");

        resizeFeaturedPosts(mastheadFeaturedPosts);

        $(window).resize(function () {
            resizeFeaturedPosts(mastheadFeaturedPosts);
        })

        $('*[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
            resizeFeaturedPosts(mastheadFeaturedPosts);
        })
    }

    function resizeFeaturedPosts(featuredPosts) {
        featuredPosts.each(function () {
            var imageTop = 84.5;
            var cardHeight = $(this).find(".item-blog-post-content").outerHeight(),
                imageHeight = $(this).find(".item-blog-post-image").outerHeight() + imageTop;

            if (cardHeight > imageHeight) {
                $(this).css("height", cardHeight);
            } else {
                $(this).css("height", imageHeight);
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlogPosts.init();
});